import { GetStockDataResponse } from 'lib/api'
import { useEffect, useState } from 'react'
import { PositionedStockStatus } from 'ui'


type Props = {
    stockData?: GetStockDataResponse
    maxStockData?: GetStockDataResponse
    en: boolean
}

const HeroStrockWrap = ({ stockData, maxStockData, en }: Props) => {
    const [yesterday, setYesterday] = useState<any>(null)
    // Check if stockData is null or undefined
    if (!stockData) { return null }

    const graph = stockData.Body.graph || maxStockData?.Body?.graph
    const maxGraph = maxStockData?.Body?.graph

    if (!graph || graph.length < 2) {
        return null
    }
    // Get yesterday closing value
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        if (!maxGraph || maxGraph.length < 2) {
            setYesterday(graph ? graph[0] : null)
            return
        }
        const last = maxGraph[maxGraph.length - 1]
        const lastDateStr = new Date(last.date).toISOString().slice(0, 10)
        // Find the last data point whose date is before the last date (by day, not time)
        let found = false
        for (let i = maxGraph.length - 2; i >= 0; i--) {
            const pointDateStr = new Date(maxGraph[i].date).toISOString().slice(0, 10)
            if (pointDateStr < lastDateStr) {

                setYesterday(maxGraph[i])
                found = true
                break
            }
        }
        if (!found) {
            setYesterday(maxGraph[maxGraph.length - 2])
        }
    }, [graph, maxGraph])

    if (!yesterday) { return null; }
    const today = graph[graph.length - 1]


    const diffAmount = parseFloat(today.price) - parseFloat(yesterday.price)
    const percentage = () => {
        const percent = (parseFloat(today.price) - parseFloat(yesterday.price)) / parseFloat(yesterday.price)
        return Math.abs(percent * 100).toFixed(2)
    }

    let increaseStatus = null;
    if (diffAmount > 0) {
        increaseStatus = true;
    } else if (diffAmount < 0) {
        increaseStatus = false;
    }
    // eslint-disable-next-line no-nested-ternary
    const symbol = increaseStatus === null ? "" : increaseStatus ? "+" : "-"

    return (
        <PositionedStockStatus
            increase={increaseStatus}
            en={en}
            title={en ? "Stock Data" : "נתוני המניה"}
            gate={parseFloat(today.price).toLocaleString("en-US", {
                maximumFractionDigits: 0,
            })}
            percentageChange={`${percentage()}%${symbol}`}
            valueChange={Math.abs(diffAmount).toFixed(2)}
            date={`${en ? "*As of " : "*נכון ל "}${new Date(
                today.date,
            ).toLocaleString("he-IL", {
                day: "2-digit",
                month: "2-digit",
                year: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
                timeZone: "Asia/Jerusalem",
            })}`}
        />
    )
}

export default HeroStrockWrap
